import { render, staticRenderFns } from "./AllLoans.vue?vue&type=template&id=22da429f&scoped=true&"
import script from "./AllLoans.vue?vue&type=script&lang=js&"
export * from "./AllLoans.vue?vue&type=script&lang=js&"
import style0 from "./AllLoans.vue?vue&type=style&index=0&id=22da429f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da429f",
  null
  
)

export default component.exports